import { action as apiAction } from 'api/Api'
import { setName } from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  elementId: number
  name: any
}

export default (payload: Payload) => async dispatch => {
  const { elementId, name } = payload

  const optimisticAction = optimisticDispatch(dispatch, setName({
    elementId,
    name: name.trim()
  }))

  try {
    await apiAction('RenameElement', {
      id: elementId,
      name: name.trim()
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) {
      throw error
    }
  }
}
